import { LoanConditionsGroup } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/ConditionsGroup/LoanConditionsGroup';

export class BnplConditionsGroup extends LoanConditionsGroup {}
